import { render } from "./img.vue?vue&type=template&id=5bf15244&scoped=true"
import script from "./img.vue?vue&type=script&lang=js"
export * from "./img.vue?vue&type=script&lang=js"

import "./img.vue?vue&type=style&index=0&id=5bf15244&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf15244"]])

export default __exports__